export enum VesselAccessEnum {
    GUEST = 0,
    EDIT = 1,//DP Trial responsible
    REVIEW = 2,
    APPROVE = 3,
    ONBOARD = 4,
    CLIENT = 5
}